// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__eNylT","row":"styles_row__bJJyD"};